import "bootstrap/dist/css/bootstrap.min.css";
// import * as tmImage from "@teachablemachine/image";
import "./FileInput.css";
import upLoadImg from "../img/upload2.svg";
import React, { useState } from "react";
import KakaoShareButton from "./KakaoShareButton";
import Spin from "./Spinner.js";

export function FileInput() {
  const [fileImage, setFileImage] = useState("");
  const [loading, setLoading] = useState(false);

  // const URL = "https://teachablemachine.withgoogle.com/models/l71aELLLN/";

  //new version
  const URL = "https://teachablemachine.withgoogle.com/models/hphD1Lqgd/";

  let model, labelContainer, maxPredictions;

  // Load the image model and setup the webcam
  async function init() {
    const modelURL = URL + "model.json";
    const metadataURL = URL + "metadata.json";

    model = await window.tmImage.load(modelURL, metadataURL);
    maxPredictions = model.getTotalClasses();

    // append elements to the DOM

    labelContainer = document.getElementById("label-container");
    for (let i = 0; i < maxPredictions; i++) {
      // and class labels
      labelContainer.appendChild(document.createElement("div"));
    }
  }

  // run the webcam image through the image model
  async function predict() {
    // predict can take in an image, video or canvas html element
    var image = document.getElementById("face");
    const prediction = await model.predict(image, false);
    prediction.sort(
      (a, b) => parseFloat(b.probability) - parseFloat(a.probability)
    );
    var resultMessage;
    var add;
    switch (prediction[0].className) {
      case "유재석":
        resultMessage = "✨유느님상✨";
        add = "영원한 1인자, 메뚜기, 날유, MC";
        break;
      case "박명수":
        resultMessage = "하찮은 박명수상";
        add = "쩜오, 억지 기부 천사, 웃음 사망꾼, 경제 개그맨, 딜러, 악마 ";
        break;
      case "정준하":
        resultMessage = "바보형 정준하상";
        add = "정중앙, 뚱뚱보, 정총무, 최고의 샌드백, 탱커, 식신";
        break;
      case "정형돈":
        resultMessage = "그냥 형돈이..상";
        add = "뚱보, 미존개오, 북경 정씨, 진상, 달님 ";
        break;
      case "노홍철":
        resultMessage = "돌아이 노홍철상";
        add = "사기꾼, 무도 내 미남, 노긍정, th, 충남의 아들 ";
        break;
      case "하하":
        resultMessage = "꼬마 하하상";
        add =
          "최고의 서포터, 상꼬맹이, 무한재석교, 레게, 백치, 석사, 하이브리드";
        break;
      case "길":
        resultMessage = "무리수 길상";
        add = "대머리, 민머리, 오줌싸개, 재미없는 친구, ";
        break;
      default:
        resultMessage = "알수없음";
    }
    const greeting = document.getElementById("result-message");
    greeting.innerHTML =
      "<div class='resultMessage  " +
      prediction[0].className +
      "-color''>" +
      resultMessage +
      "</div><div class='add'>" +
      add +
      "</div>";

    console.log(prediction);
    var barWidth;
    for (let i = 0; i < maxPredictions; i++) {
      // const classPrediction =
      //   prediction[i].className + ": " + prediction[i].probability.toFixed(2);
      // labelContainer.childNodes[i].innerHTML = classPrediction;

      if (prediction[i].probability.toFixed(2) > 0.1) {
        barWidth = Math.round(prediction[i].probability.toFixed(2) * 100) + "%";
      } else if (prediction[i].probability.toFixed(2) >= 0.01) {
        barWidth = "4%";
      } else {
        barWidth = "2%";
      }
      var labelTitle;
      switch (prediction[i].className) {
        case "유재석":
          labelTitle = "유재석";
          break;
        case "박명수":
          labelTitle = "박명수";
          break;
        case "정준하":
          labelTitle = "정준하";
          break;
        case "정형돈":
          labelTitle = "정형돈";
          break;
        case "노홍철":
          labelTitle = "노홍철";
          break;
        case "하하":
          labelTitle = "하하";
          break;
        case "길":
          labelTitle = "길";
          break;
        default:
          labelTitle = "알수없음";
      }
      var label =
        "<div class='label animal-label d-flex align-items-center'>" +
        labelTitle +
        "</div>";
      var bar =
        "<div class='bar-container position-relative container'><div class='" +
        prediction[i].className +
        "-box'></div><div class='d-flex justify-content-center align-items-center " +
        prediction[i].className +
        "-bar' style='width: " +
        barWidth +
        "'><span class='d-block percent-text'>" +
        Math.round(prediction[i].probability.toFixed(2) * 100) +
        "%</span></div></div>";
      labelContainer.childNodes[i].innerHTML =
        "<div class='d-flex'>" + label + bar + "</div>";
    }
  }

  // 파일 저장
  const saveFileImage = (e) => {
    setFileImage(window.URL.createObjectURL(e.target.files[0]));
    setLoading(true);
    init().then(function () {
      predict();
      setLoading(false);
    });
  };

  // 파일 삭제
  const deleteFileImage = () => {
    // window.URL.revokeObjectURL(fileImage);
    // setFileImage("");
    window.location.reload();
  };

  return (
    <>
      <script src="https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@1.3.1/dist/tf.min.js"></script>
      <script src="https://cdn.jsdelivr.net/npm/@teachablemachine/image@0.8.3/dist/teachablemachine-image.min.js"></script>{" "}
      <script
        class="jsbin"
        src="https://ajax.googleapis.com/ajax/libs/jquery/1/jquery.min.js"
      ></script>
      {/* <script
        type="text/javascript"
        src="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-62459ad26e336ff7"
      ></script> */}
      <div class="file-upload">
        {!fileImage ? (
          <div class="image-upload-wrap">
            <input
              class="file-upload-input"
              type="file"
              accept="image/*"
              onChange={saveFileImage}
            />
            <div class="drag-text">
              <img src={upLoadImg} class="upload" alt="upload" />
              <h3>얼굴 사진을 올려놓거나 눌러서 업로드하세요!</h3>
              {/* <span>얼굴만 나온 사진일수록 정확합니다.</span> */}
            </div>
          </div>
        ) : (
          <img
            class="file-upload-image"
            id="face"
            src={fileImage}
            alt="yours"
          />
        )}

        <div class="file-upload-content">
          {loading && <Spin />}
          <div id="result-message"></div>
          <div id="label-container"></div>

          <div class="image-title-wrap">
            {fileImage && !loading && (
              <>
                <KakaoShareButton />
                <button
                  type="button"
                  class="remove-image"
                  onClick={deleteFileImage}
                >
                  삭제 {/* <span class="image-title">새 그림 불러오기</span> */}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <div class="no-save">* 사진은 저장되지 않습니다. *</div>
      {/* <button type="button" onClick={init}>
        Start
      </button> */}
      {/* <button type="button" onClick={predict}>
        예측
      </button> */}
      <script src="https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@1.3.1/dist/tf.min.js"></script>
      <script src="https://cdn.jsdelivr.net/npm/@teachablemachine/image@0.8/dist/teachablemachine-image.min.js"></script>
      <script type="text/javascript"></script>
      {/* Copyright (c) 2022 by Aaron Vanston (https://codepen.io/aaronvanston/pen/yNYOXR)

      Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */}
    </>
  );
}

export default FileInput;
